import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
// var API = "https://hscodes.world:8888/nodeapp";
//var API = "https://localhost:8888/nodeapp";  
// var API = "http://localhost:5962/nodeapp";
//var API = "https://api.hscodes.world/nodeapp";
var API = "https://newapi.hscodes.world/nodeapp";

/*
  Generated class for the ApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({ providedIn: 'root'})
export class ApiProvider {
  loading: any;
  private messageSource = new BehaviorSubject([]);
  currentMessage = this.messageSource.asObservable();

  private returnCountrys = new BehaviorSubject([]);
  currentCountrys = this.returnCountrys.asObservable();

  sections: any[] = [];
  allCountrys: any[] = [];

  constructor(public http: HttpClient,
    private loadingCtrl:LoadingController ) {
    console.log('Hello ApiProvider Provider');
  }
 

  // loader start
  async presentLoadingIos() {
    this.loading = await this.loadingCtrl.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      spinner: 'lines'
    });
  
    await this.loading.present();
  }
  //loader end

  login(lndata) {
    return this.http.post(API + '/newuserlogin', lndata)
  }
  getagentmobilelogin(lndata) {
    return this.http.post(API + '/getagentmobilelogin', lndata)
  }
  signup(spdata) {
    console.log(spdata)
    return this.http.post(API + '/newusersignup', spdata)
  }
  postappdemovideos(data) {
    return this.http.post(API + '/postappdemovideos', data);
  }
  changepassworddashboard(data) {
    console.log(data)
    return this.http.post(API + '/changepassworddashboard', data)
  }
  changepassworduser(data) {
    console.log(data)
    return this.http.post(API + '/changepassworduser', data)
  }
  updateagentaccount(data) {
    console.log(data)
    return this.http.post(API + '/updateagentaccount', data)
  }
  getAgentRefId(data) {
    return this.http.post(API + '/agent_refid', data);
  }
  geteximdata(data) {
    return this.http.post(API + '/geteximdata', data)
  }
  getContinentdata() {
    var data = {
      'indicator': 0
    }
    return this.http.post(API + '/continents', data)
  }

  // getextCitydata() {
  //   var data = {
  //     'indicator': 0
  //   }
  //   return this.http.get(ExtAPI + '/LocationInDropdown')
  // }

  getLeadsData() {
    var data = {
      'indicator': 0
    }
    return this.http.post(API + '/leadcategories', data)
  }

  getCurrency() {
    var data = {
      'indicator': 0
    }
    return this.http.post(API + '/currencies', data)
  }

  getallCountrys() {
    var data = {
      'indicator': 0
    }
    return this.http.post(API + '/allcountries', data)
  }
  addhscode(data) {
    return this.http.post(API + '/addhscode', data)
  }

  bannerdata(data) {
    return this.http.post(API + '/bannerdata', data);
  }

  getSearchallCountrys() {
    var data = {
      'indicator': 0
    }
    this.http.post(API + '/allcountries', data).subscribe((res: any) => {
      this.allCountrys = res.data;
      this.returnCountrysData();
    }, er => {
    })
  }

  returnCountrysData() {
    this.returnCountrys.next(this.allCountrys);
  }



  getSectionData() {
    var data = {
      'indicator': 0
    }
    return this.http.post(API + '/sections', data)
  }

  getCountrysdata(data) {

    return this.http.post(API + '/countries', data)
  }

  getleadcntchapters(data) {
    return this.http.post(API + '/getleadcntchapters', data);
  }

  homeData(data) {
    console.log(this.sections);
    this.http.post(API + '/sections', data).subscribe((res: any) => {
      this.sections = res.data;
      console.log(res.data);

      this.returnHomeData();

    }, er => {
      console.log(er);
      // console.log(er.error)
      // this.doAlert1()
      // alert(er.error);
    });
  }


  returnHomeData() {
    this.messageSource.next(this.sections);
  }


  getStatesdata(data) {
    return this.http.post(API + '/states', data)
  }

  getPortsTypedata(data) {
    return this.http.post(API + '/getporttype', data)
  }

  getPortsdata(data) {
    return this.http.post(API + '/selectedports', data)
  }

  agencyDataSubmit(data) {
    return this.http.post(API + '/postagencydata', data)
  }

  FranchiseDataSubmit(data) {
    return this.http.post(API + '/postfranchisedata', data)
  }

  checkAvilability(data) {
    console.log(data)
    return this.http.post(API + '/check_franchise', data)
  }

  LeadsDataSubmit(data) {
    console.log(data)
    return this.http.post(API + '/postleaddataMbl', data)
  }

  LeadscntryDataSubmit(data) {
    console.log(data)
    return this.http.post(API + '/postcntryleaddataMbl', data)
  }
  searchProductName(data) {
    return this.http.post(API + '/getsearchdata', data)
  }
  dontKnowHscode(data) {
    return this.http.post(API + '/dontknowhscode', data)
  }
  getHscodedata(data) {
    return this.http.post(API + '/hscodesdata', data)
  }

  getSubscriptionDetails(data) {
    return this.http.post(API + '/membershipdtls_description', data)
  }

  getserviceSubscriptionDetails(data) {
    return this.http.post(API + '/services_description', data)
  }

  getleadsDataWise(lead) {
    return this.http.post(API + '/getleaddetails', lead)
  }

  getCntryleadsDataWise(lead) {
    return this.http.post(API + '/getcntryleaddetails', lead)
  }

  paymentSubmit(data) {
    return this.http.post(API + '/postmembershipdetails', data)
  }

  paymentServiceSubmit(data) {
    return this.http.post(API + '/postservicememberdetails', data)
  }

  addfovouritesDtata(data) {
    return this.http.post(API + '/addfovourites', data)
  }

  removefovouritesData(data) {
    return this.http.post(API + '/removefovourites', data)
  }

  homeSlidesData(data) {
    return this.http.post(API + '/getsliders', data)
  }

  getFavouriteDataApi(data) {
    return this.http.post(API + '/getfavourites', data)
  }

  userDetailsUpdate(data) {
    return this.http.post(API + '/userData', data)
  }
  userprofiledata(data) {
    return this.http.post(API + '/userprofiledata', data)
  }
  // babu
  getchaptersdata(data) {
    return this.http.post(API + '/chapters', data)
  }
  getviewpackagedeatils(data) {
    return this.http.post(API + '/getmembershipdtls', data)
  }
  getusersectionsdata(data) {
    return this.http.post(API + '/getusersectionsdata', data)
  }
  updateprofileImage(data) {
    return this.http.post(API + '/updateprofileImage', data)
  }
  viewcreditsupdate(data) {
    return this.http.post(API + '/updateviewcreditsdata', data)
  }
  getsubscriptiondata(data) {
    return this.http.post(API + '/getsubscriptiondata', data)
  }
  getusingleads(data) {
    return this.http.post(API + '/getusingleads', data)
  }

  getagencydetails(data) {
    return this.http.post(API + '/getagencydetailsdata', data)
  }

  submitrequestdata(data) {
    console.log("hittedapi");

    return this.http.post(API + '/postrequestquote', data)
  }
  getbuyerdatadeatils(data) {
    return this.http.post(API + '/getbuyerdetailsdata', data)
  }
  sentquetionrequests(data) {
    return this.http.post(API + '/gethsrmdaatdetails', data)
  }
  getCountryid(data) {
    var dataa = {
      'country': data
    }

    return this.http.post(API + '/getCountryid', dataa)
  }
  verificationmail() {
    return this.http.get(API + '/verificationmail/' + 0)
  }
  sendipdeatils(data) {
    return this.http.post(API + '/submitipdetails', data)
  }
  forgotpasword(data) {
    return this.http.post(API + '/forgetpassword', data)
  }

  forgetwefpassword(data) {
    return this.http.post(API + '/forgetwefpassword', data)
  }
  searchGroups(data) {
    return this.http.post(API + '/getchatgroupdata', data)
  }
  AddGroups(data) {
    return this.http.post(API + '/getchatgroupdata', data)
  }

  getGroups(data) {
    return this.http.post(API + '/getchatgroupdata', data)
  }

  getAllGroups(data) {
    return this.http.post(API + '/getchatgroupdata', data)
  }
  removeChatGroup(data) {
    return this.http.post(API + '/getchatgroupdata', data)
  }
  updatepublicplayerid(data) {
    return this.http.post(API + '/updatepublicplayerid', data)
  }
  headers: any = {
    'Accept': 'application/json',
    'Authorization': 'Bearer 2|ZyEmHJHBteF16EYLZbixaPxHPuD8DFoasGfRh7Rv',
  }
  ///
  getAdminInitiatiteMeetingDltsSer() {
    return this.http.get(API + '/getmobilesvrvisionmeetingapi')
  }

  joinMeetingSer(data) {
    console.log(data);
    return this.http.post('https://secure.telmeet.in/api/v1/meeting/join', data, { headers: this.headers });
  }

  remindmeLaterData(data) {
    return this.http.post(API + '/postremainderleaddata', data)
  }

  // dummyData() {
  //   return this.http.get(LocalAPI + '/getall')
  // }


  // storeJoinersSer(sdata) {
  //   return this.http.post(API + '/storeJoiners', sdata)
  // }

  addPoliciesData(policyData) {
    return this.http.post(API + '/postpolicydata', policyData)
  }

  addRFQData(rfqData) {
    return this.http.post(API + '/postrfqdata', rfqData)
  }

  postwelcomemessage(data) {
    return this.http.post(API + '/postwelcomemessage', data)
  }

  flagsdata(data) {
    return this.http.post(API + '/flagsdata', data)
  }

  gethsrmdaatdetails(data) {
    return this.http.post(API + '/gethsrmdaatdetails', data)
  }


  generateleaddisplayId() {
    return this.http.get(API + '/generateleaddisplayId')
  }
  getallusers(data) {
    return this.http.post(API + '/getallusers', data)
  }
  certifyingagencies(data) {
    return this.http.post(API + '/certifyingagencies', data)
  }

  serviceprovider(data) {
    return this.http.post(API + '/serviceprovider', data)
  }

  removechatgroupfromchat(data) {
    return this.http.post(API + '/removechatgroupfromchat', data)
  }
  getrestrictiondata(data) {
    return this.http.post(API + '/getrestrictiondata', data)
  }

  postenquiry(data) {
    return this.http.post(API + '/postenquiry', data)
  }

  getagentbasedusers(data) {
    return this.http.post(API + '/getagentbasedusers', data)
  }
  getagentmainuserid(data) {
    return this.http.post(API + '/getagentmainuserid', data)
  }
  getagentslabcommdata(data) {
    return this.http.post(API + '/getagentslabcommdata', data);
  }
  getallCountrysdata() {
    var data = {
      'indicator': 0
    }
    return this.http.post(API + '/allcountries', data)
  }
  getagentpayoutdata(data) {
    return this.http.post(API + '/getagentpayoutdata', data);
  }
  getagentpayoutmonthlydata(data) {
    return this.http.post(API + '/getagentpayoutmonthlydata', data);
  }
  getagentaccountsdata(data) {
    return this.http.post(API + '/getagentaccountsdata', data);
  }
  getagentusersdata(data) {
    return this.http.post(API + '/getagentusersdata', data);
  }
  getagentleads(lead) {
    return this.http.post(API + '/getagentleads', lead)
  }
  deleteUser(data) {
    return this.http.post(API + '/deleteUser', data);
  }

  validatecpncode(data) {
    return this.http.post(API + '/cpndtls_validatecode', data)
  }
  updatecpncode(data) {
    return this.http.post(API + '/cpndtls_useruse', data)
  }

  getServiceProviderdata() {
    var data = {
      'indicator': 0
    }
    return this.http.post(API + '/serviceprovidergroup', data)
  }
}
